import { ref } from 'vue'

import { checkboxFieldPlugin } from '@/features/settingsManagement/fieldManagement/edit/plugin/checkboxFieldPlugin/checkboxFieldPlugin.js'
import { datetimePickerFieldPlugin } from '@/features/settingsManagement/fieldManagement/edit/plugin/datetimePickerFieldPlugin/datetimePickerFieldPlugin.js'
import { inputFieldPlugin } from '@/features/settingsManagement/fieldManagement/edit/plugin/inputFieldPlugin/inputFieldPlugin.js'
import { radioFieldPlugin } from '@/features/settingsManagement/fieldManagement/edit/plugin/radioFieldPlugin/radioFieldPlugin.js'
import { selectFieldPlugin } from '@/features/settingsManagement/fieldManagement/edit/plugin/selectFieldPlugin/selectFieldPlugin.js'
import { selectMultipleFieldPlugin } from '@/features/settingsManagement/fieldManagement/edit/plugin/selectMultipleFieldPlugin/selectMultipleFieldPlugin.js'
import { switchFieldPlugin } from '@/features/settingsManagement/fieldManagement/edit/plugin/switchFieldPlugin/switchFieldPlugin.js'
import { textareaFieldPlugin } from '@/features/settingsManagement/fieldManagement/edit/plugin/textareaFieldPlugin/textareaFieldPlugin.js'

export const fieldPlugins = ref(new Map()) // <Map<string, FieldPlugin>>

export function registerFieldPlugin(plugin) {
  fieldPlugins.value.set(plugin.type, plugin)
}

export function useFieldPlugins() {
  return {
    registerPlugin: registerFieldPlugin,
    getPlugin: type => fieldPlugins.value.get(type),
    hasPlugin: type => fieldPlugins.value.has(type),
    getAllPlugins: () => Array.from(fieldPlugins.value.values()),
  }
}

export function setupFieldPlugins() {
  const { registerPlugin } = useFieldPlugins()

  const fieldPlugins = [
    inputFieldPlugin,
    textareaFieldPlugin,
    checkboxFieldPlugin,
    switchFieldPlugin,
    datetimePickerFieldPlugin,
    selectFieldPlugin,
    radioFieldPlugin,
    selectMultipleFieldPlugin,
  ]

  fieldPlugins.forEach(plugin => {
    registerPlugin(plugin)
  })
}
